import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";
import FeatherIcon from 'feather-icons-react';
import { useSelector, useDispatch } from 'react-redux';
import { Collapse, Typography, Divider, message, Row, Col, Spin } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import AccountIntePage from './AccountIntePage'
import { setChatCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import { FetchUserDetails } from "../../../../Api/Services/UserApiService"
import { FetchAccountDetails } from "../../../../Api/Services/AccountApiService"
import { FetchContactDetails } from "../../../../Api/Services/ContactApiService"
import { fetchDomainAvaliability, extractDomain } from "../../../../Api/Services/CompanyApiService"
import { AccountsIcon, StaffIcon, ReportsIcon, ScoreIcon } from '../../../../components/Icons/Icons';
import Meeting from '../../TablesAndTimelines/MeetingTable'
import Scoring from "../../TablesAndTimelines/ScoringGrapg"
import { RelatedDocs } from '../GlobalComponents/RelatedDocUpload'
import { UserSideDiv } from '../GlobalComponents/UserCardCmnts';
import { contactInsights } from '../../../../Api/Services/CommonApiService';

const { Panel } = Collapse;
const { Text } = Typography;

const NoteDetails = ({ displayData, profile, ViewDetailPage, UrlId, NacTrigger, setNaCTrigger, trigger }) => {
    const dispatch = useDispatch()
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const companyProfile = localData.company
    const [report, setReport] = useState()
    const [userData, setUserData] = useState()
    const [contactData, setContactData] = useState()
    const [accountData, setAccountData] = useState()
    const [isOpen4, setIsOpen4] = useState(false);
    const [isOpen5, setIsOpen5] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen2, setIsOpen2] = useState(true);
    const [isOpen3, setIsOpen3] = useState(true);
    const [openIntelligence, setOpenIntelligence] = useState(false);

    async function getAccountReports(params) {
        try {
            const ValidDomain = await extractDomain(params)
            if (ValidDomain) {
                const Response = await fetchDomainAvaliability(ValidDomain)
                if (Response === "") {
                    setReport({ allow: false, data: null })
                }
                else {
                    setReport({ allow: true, data: Response })
                }
            }
        } catch (error) {
            message.error(error)
        }
    }
    async function getUsersData(params) {
        try {
            const Response = await FetchUserDetails(params)
            setUserData(Response?.data)
        } catch (error) {
            message.error(error)
        }
    }
    async function getAccountData(params) {
        try {
            const responseData = await FetchAccountDetails(params)
            const Response = responseData.data
            const merged = { ...Response, DataPermission: { isPresent: responseData.allow }, };
            setAccountData(merged)
            if (merged?.website) {
                getAccountReports(merged?.website)
            } else {
                setReport({ allow: false, data: null })
            }
        } catch (error) {
            message.error(error)
        }
    }
    async function getContactData(params) {
        try {
            const responseData = await FetchContactDetails(params)
            const Response = responseData.data
            const merged = { ...Response, DataPermission: { isPresent: responseData.allow }, };
            setContactData(merged)
        } catch (error) {
            message.error(error)
        }
    }
    const handleExpand5 = (key) => {
        setIsOpen5(key.length > 0);
    };
    const handleExpand4 = (key) => {
        setIsOpen4(key.length > 0);
    };
    const handleExpand = (key) => {
        setIsOpen(key.length > 0);
    };
    const handleExpand2 = (key) => {
        setIsOpen2(key.length > 0);
    };
    const handleExpand3 = (key) => {
        setIsOpen3(key.length > 0);
    };
    useEffect(() => {
        if (isOpen4) {
            if (displayData?.lead_owner) {
                getUsersData(displayData?.lead_owner)
            } else {
                setUserData()
            }
        }
    }, [displayData?.lead_owner, isOpen4])
    useEffect(() => {
        if (isOpen2) {
            if (displayData?.account_id) {
                getAccountData(displayData?.account_id)
            } else {
                setAccountData()
            }
        }
    }, [displayData?.account_id, isOpen2])
    useEffect(() => {
        if (isOpen5) {
            if (displayData?.reporting_to) {
                getContactData(displayData?.reporting_to)
            } else {
                setContactData()
            }
        }
    }, [displayData?.reporting_to, isOpen5])
    const openTacking = () => {
        setOpenIntelligence(!openIntelligence)
    }
    const memoUrlId = useMemo(
        () => UrlId,
        [UrlId?.[0], UrlId?.[1]]
    );
    const openScoreGeniee = async () => {
        let hideMessage;
        try {
            hideMessage = message.loading("Gathering insights...", 0);
            const response = await contactInsights(companyProfile.companyCode, memoUrlId[1])
            if (response.status === 200) {
                hideMessage();
                dispatch(setChatCall(true));
            }
        }
        catch (error) {
            hideMessage();
            message.error(error)
        }
    }
    return (
        <>
            <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand3} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end">
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}> <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        minWidth: 0,
                    }}
                >
                    <Text
                        strong
                        style={{
                            fontSize: 14,
                            whiteSpace: "nowrap",
                            flexShrink: 0,
                        }}
                    >
                        Contact Score
                    </Text>
                    <div className='Hover-Refresh3 back-hover2 able-style'
                        role="button"
                        tabIndex={0} title='View Score Insights'
                        onClick={(e) => {
                            e.stopPropagation();   // ✅ IMPORTANT
                            openScoreGeniee();
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.stopPropagation();
                                openScoreGeniee()
                            }
                        }}
                        aria-label='insights'
                    ><ScoreIcon height={20} width={20} /></div>
                </div>
                    <Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen3 ? "Close" : "View"}</Text></div>} key="1">
                    {/* <div className='RightSide-DataShadow' style={{ padding: "30px 10px" }}> */}
                    <Scoring UrlId={memoUrlId} NacTrigger={NacTrigger} trigger={trigger} />
                    {/* </div> */}
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
            <Meeting UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} type="List" />
            {(displayData?.account_id && accountData) && <>
                <Divider style={{ margin: "10px 0" }} />
                <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand2} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end">
                    <Panel header={
                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    minWidth: 0,
                                }}
                            >
                                <Text
                                    strong
                                    style={{
                                        fontSize: 14,
                                        whiteSpace: "nowrap",
                                        flexShrink: 0,
                                    }}
                                >
                                    Account
                                </Text>

                                {isOpen2 ? <div className={!report?.allow ? "disabled-style" : 'Hover-Refresh3 back-hover2 able-style'}
                                    role="button"
                                    tabIndex={0} title='View Account Intelligence Report'
                                    onClick={!report?.allow ? undefined : () => openTacking()}
                                    onKeyDown={(event) => {
                                        if (report?.allow && (event.key === 'Enter' || event.key === ' ')) {
                                            openTacking()
                                        }
                                    }}
                                    aria-label='report'
                                ><ReportsIcon height={20} width={20} /></div> : <></>}
                            </div>
                            <Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen2 ? "Close" : "View"}</Text></div>} key="1">
                        {accountData ? <div className='RightSide-DataShadow'>
                            <div className={`user-info_image ${accountData?.DataPermission?.isPresent && "ListNavigate"}`}
                                style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }} tabIndex={0} role="button"
                                onClick={accountData?.DataPermission?.isPresent ? () => accountData?.account_id && ViewDetailPage(accountData?.account_id, "ACCOUNT") : undefined}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        ViewDetailPage(accountData?.account_id, "ACCOUNT")
                                    }
                                }}
                            >
                                {accountData?.account_profile !== null && accountData?.account_profile
                                    !== undefined && accountData?.account_profile !== "" ?
                                    <figure>
                                        <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={accountData?.account_profile} alt="" />
                                    </figure>
                                    :
                                    <span className='list_span_Tag AccountIcon' style={{ flexShrink: 0, }}>
                                        {accountData?.account_name?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <figcaption style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    overflow: "hidden", // 👈 keeps ellipsis responsive
                                }}>
                                    <div style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={accountData?.account_name}>{accountData?.account_name}</div>
                                    <div style={{
                                        fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={accountData?.account_number}>{accountData?.account_number}</div>
                                </figcaption>
                            </div>
                            <Row gutter={30}>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.industry_name && accountData?.industry_name !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Industry</Text>
                                            <br />
                                            <Text >{accountData?.industry_name}</Text>
                                        </div> : <></>}</Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.nom_of_employees && accountData?.nom_of_employees !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>No of Employees</Text>
                                            <br />
                                            <Text >{accountData?.nom_of_employees}</Text>
                                        </div> : <></>}
                                </Col>
                            </Row>
                            <Row gutter={30}>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.annual_revenue && accountData?.annual_revenue !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Annual Revenue</Text> <br />
                                            <Text >{accountData?.annual_revenue}</Text>
                                        </div> : <></>}</Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.rating && accountData?.rating !== "") ?
                                        <div><Text type="secondary" className='RightSide-Lable'>Rating</Text> <br />
                                            <Text >{accountData?.rating}</Text>
                                        </div> : <></>}
                                </Col>
                            </Row>
                            {accountData?.account_owner &&
                                <div><Text type="secondary" className='RightSide-Lable'>Account Owner</Text> <br />
                                    <Text >
                                        <div className={`user-info_image ${(Role === "Administrator" || profile.userId === accountData?.account_owner) && "ListNavigate"}`}
                                            role="button" style={{ padding: "5px 0px 0px", display: "flex", alignItems: "center", minWidth: 0, }}
                                            tabIndex={0}
                                            onClick={(Role === "Administrator" || profile.userId === accountData?.account_owner) ? () => accountData?.account_owner && ViewDetailPage(accountData?.account_owner, "USER") : undefined}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter' || event.key === ' ') {
                                                    ViewDetailPage(accountData?.account_owner, "USER");
                                                }
                                            }}> {accountData?.userProfilePic !== null && accountData?.userProfilePic
                                                !== undefined && accountData?.userProfilePic !== "" ?
                                                <figure>
                                                    <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={accountData?.userProfilePic} alt="" />
                                                </figure>
                                                :
                                                <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                                                    {accountData?.userFirstName?.slice(0, 1).toUpperCase()}
                                                </span>
                                            }
                                            <figcaption style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                overflow: "hidden", // 👈 keeps ellipsis responsive
                                            }}>
                                                <div style={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={`${accountData?.userFirstName} ${accountData?.userLastName}`}> {`${accountData?.userFirstName} ${accountData?.userLastName}`}</div>
                                                <div style={{
                                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={accountData?.accountOwner}>{accountData?.accountOwner}</div>
                                            </figcaption>
                                        </div>
                                    </Text>
                                </div>
                            }
                        </div> : <div className='RightSide-DataShadow'>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "10rem"
                            }}>
                                <Spin />
                            </div>
                        </div>}
                    </Panel>
                </Collapse></>}
            {displayData?.reporting_to ?
                <><Divider style={{ margin: "10px 0" }} />
                    <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand5} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                        <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Reporting To</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen5 ? "Close" : "View"}</Text></div>} key="1">
                            {contactData ? <div className='RightSide-DataShadow'>
                                <div className={`user-info_image ${contactData?.DataPermission?.isPresent && "ListNavigate"}`}
                                    role="button" style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
                                    tabIndex={0}
                                    onClick={contactData?.DataPermission?.isPresent ? () => contactData?.contacts_id && ViewDetailPage(contactData?.contacts_id, "CONTACT") : undefined}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter' || event.key === ' ') {
                                            ViewDetailPage(contactData?.contacts_id, "CONTACT")
                                        }
                                    }}
                                >  {contactData?.contact_profile !== null && contactData?.contact_profile
                                    !== undefined && contactData?.contact_profile !== "" ?
                                    <figure>
                                        <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={contactData?.contact_profile} alt="" />
                                    </figure>
                                    :
                                    <span className='list_span_Tag ContactIcon' style={{ flexShrink: 0, }}>
                                        {contactData?.first_name?.slice(0, 1).toUpperCase()}
                                    </span>
                                    }
                                    <figcaption style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        overflow: "hidden", // 👈 keeps ellipsis responsive
                                    }}>
                                        <div title={`${contactData?.first_name} ${contactData?.last_name}`}
                                            style={{
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }}> {`${contactData?.first_name} ${contactData?.last_name}`}</div>
                                        <div style={{
                                            fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }} title={contactData?.email}>{contactData?.email}</div>
                                    </figcaption>
                                </div>
                                {(contactData?.designation && contactData?.designation !== "") &&
                                    <div style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                                        <StaffIcon height={15} width={15} marginRight={5} />{contactData?.designation}
                                    </div>}
                                {(contactData?.mobile && contactData?.mobile !== "") &&
                                    <div style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                                        <FeatherIcon icon="phone" size={15} style={{ display: "flex", alignItems: "center", marginRight: 5 }} />{contactData?.mobile}
                                    </div>}
                                {contactData?.account_id &&
                                    <div style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                                        <AccountsIcon height={15} width={15} marginRight={5} />{contactData?.account_name}
                                    </div>}
                            </div> : <div className='RightSide-DataShadow'>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "10rem"
                                }}>
                                    <Spin />
                                </div>
                            </div>}
                        </Panel>
                    </Collapse ></> : <></>}
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand4} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Contact Owner</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen4 ? "Close" : "View"}</Text></div>} key="1">
                    <UserSideDiv userData={userData} />
                </Panel>
            </Collapse >
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", }}><div style={{ fontWeight: 600 }}>Documents<span style={{ background: "#f0f0f0", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: 500, marginLeft: "10px", }}>{displayData?.contact_files?.length || 0}</span></div><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen ? "Close" : "View"}</Text></div>} key="1">
                    {displayData?.contact_files?.map((file, index) => (
                        <RelatedDocs file={file} index={index} />
                    ))}
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
            <AccountIntePage openIntelligence={openIntelligence} openTacking={openTacking} researchContent={report?.data} />
        </>
    );
};
NoteDetails.propTypes = {
    displayData: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    ViewDetailPage: PropTypes.func.isRequired,
    // Role: PropTypes.string.isRequired,
    UrlId: PropTypes.array.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    trigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
};
export default NoteDetails;
